import { InjectionToken } from '@angular/core';
import { Environment } from '@shared/interfaces/environment';

export const ENVIRONMENT = new InjectionToken<Environment>('Environment');
